import './AppTable.scss';
import { TablePagination } from '@mui/material';
import { DataGrid, GridColDef, GridRowClassNameParams } from '@mui/x-data-grid';
import { useState } from 'react';

interface Props {
  columns: GridColDef[];
  pageSize: number;
  rows: any[];
  pageNumber?: number;
  serverSidePagination?: boolean;
  serverSidePaginationCount?: number;
  getRowClassName?: ((params: GridRowClassNameParams<any>) => string);
  handleOnClickSearch?: (pageNumber?: number, pageSize?: string) => void;
  rowsPerPageLabel?:string;
}

const AppTable = ({columns, pageSize, rows, pageNumber, serverSidePagination, serverSidePaginationCount, getRowClassName, handleOnClickSearch, rowsPerPageLabel}: Props) => {

    const [pageSizeInternal, setPageSizeInternal] = useState(pageSize);

    const getDataGridSxProps = () => {
        return {
            border: 'none',
            fontSize: '1.6rem',

            '& .MuiDataGrid-cellContent': {
                paddingLeft: '1rem'
            },

            '& .MuiDataGrid-columnHeader' : {
                color: '#494f56',
                fontSize: '1.4rem',
                outline: 'none !important',
                paddingLeft: '2rem',

                '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: '600'
                },
                
                '& .MuiDataGrid-iconSeparator': {
                    display: 'none'
                }
            },

            '& .MuiDataGrid-footerContainer' : {
                borderTop: 'none'
            },

            '& .MuiDataGrid-menuIcon' : {
                display: 'none'
            },

            '& .MuiInputBase-root': {
                fontSize: '1.4rem'
            },

            '& .MuiSvgIcon-root': {
                fontSize: 24
            },

            '& .MuiTablePagination-displayedRows': {
                fontSize: '1.4rem',
                display: serverSidePagination ? 'none' : 'block'
            },

            '& .MuiTablePagination-selectLabel': {
                fontSize: '1.4rem'
            }
        }
    }

    const getTablePaginationSxProps = () => {
        return {
            '& .MuiInputBase-root': {
                fontSize: '1.4rem'
            },

            '& .MuiSvgIcon-root': {
                fontSize: 24
            },

            '& .MuiTablePagination-displayedRows': {
                fontSize: '1.4rem',
            },

            '& .MuiTablePagination-selectLabel': {
                fontSize: '1.4rem'
            }
        }
    }
    
    return (
        <>
            <DataGrid
                autoHeight
                columns={columns}
                disableSelectionOnClick
                getRowClassName={getRowClassName}
                getRowHeight={() => 'auto'}
                hideFooterPagination={serverSidePagination}
                onPageSizeChange={p => !serverSidePagination && setPageSizeInternal(p)}
                pagination
                pageSize={serverSidePagination ? pageSize : pageSizeInternal}
                rows={rows}
                rowsPerPageOptions={[10, 25, 50, 100]}
                sx={getDataGridSxProps()}
                localeText={{
                    MuiTablePagination: {
                        labelRowsPerPage: rowsPerPageLabel ? rowsPerPageLabel : 'Rows per page : ',
                    }
                }}
            />
            {serverSidePagination && (
                <TablePagination
                    component="div"
                    count={serverSidePaginationCount ?? pageSize}
                    labelDisplayedRows={({from, to}) => `${from}-${rows.length < to ? (from - 1) + rows.length : to}`}
                    page={pageNumber ?? 0}
                    onPageChange={(e, p) => handleOnClickSearch && handleOnClickSearch(p)}
                    rowsPerPage={pageSize}
                    onRowsPerPageChange={(e) => handleOnClickSearch && handleOnClickSearch(undefined, e.target.value)}
                    sx={getTablePaginationSxProps()}
                    labelRowsPerPage={rowsPerPageLabel ? rowsPerPageLabel : 'Rows per page : '}
                />
            )}
        </>
    );
};

export default AppTable;
